/**
 * Film layout data shared by the stages and their HTML label overlay.
 * Stage units (viewBox "100 105 1400 700", the safe frame).
 */

export const STAGE_VIEWBOX = '100 105 1400 700'

/** End-card labels: each sits on its register leader's shelf. */
export const PAD_REGISTER_ANCHOR = [1420, 480]
export const SCREEN_REGISTER_ANCHOR = [1420, 505]
export const ASSEMBLY_REGISTER_ANCHOR = [1540, 466]
